import React from "react";
import "./DredgingServices.css";

const DredgingServices = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis,
        nesciunt.
      </h1>
    </div>
  );
};

export default DredgingServices;
